import { LOCALE } from '@foxrenderfarm/internals'
import {
  ArnoldSolutionIcon,
  BlenderSolutionIcon,
  C4DSolutionIcon,
  HoudiniSolutionIcon,
  MayaSolutionIcon,
  MaxSolutionIcon,
  NukeSolutionIcon,
  UnrealSolutionIcon,
  VRaySolutionIcon,
} from '../../../svg'
import { getLocalAppOrigin, isPathActive, MainLink } from '../../light-dropdowns/common'
import { MobileNavIconGrid } from '../atoms'

interface SolutionsPanelProps {
  currentLocale: LOCALE
  currentPathname: string
  origin: string
}

export const SolutionsPanel = ({ currentLocale, currentPathname, origin }: SolutionsPanelProps) => {
  const useGatsbyLink = process.env.GATSBY_PACKAGE_NAME === 'main'
  const mainOrigin = getLocalAppOrigin(origin, 8084)
  const items = [
    { to: '/blender-render-farm.html', label: 'Blender', Icon: BlenderSolutionIcon },
    { to: '/3ds-max-render-farm.html', label: '3ds Max', Icon: MaxSolutionIcon },
    { to: '/maya-render-farm.html', label: 'Maya', Icon: MayaSolutionIcon },
    { to: '/c4d-render-farm.html', label: 'Cinema 4D', Icon: C4DSolutionIcon },
    { to: '/houdini-render-farm.html', label: 'Houdini', Icon: HoudiniSolutionIcon },
    { to: '/unreal-engine-render-farm.html', label: 'Unreal Engine', Icon: UnrealSolutionIcon },
    { to: '/arnold-render-farm.html', label: 'Arnold', Icon: ArnoldSolutionIcon },
    { to: '/vray-render-farm.html', label: 'V-Ray', Icon: VRaySolutionIcon },
    { to: '/nuke-render-farm.html', label: 'Nuke', Icon: NukeSolutionIcon },
  ]

  return (
    <MobileNavIconGrid>
      {items.map((item) => {
        const Icon = item.Icon
        return (
          <MainLink
            key={item.to}
            to={item.to}
            href={`${mainOrigin}${item.to}`}
            useGatsbyLink={useGatsbyLink}
            locale={currentLocale}
            $highlight={isPathActive(currentPathname, item.to, currentLocale)}
          >
            {Icon && <Icon />}
            {item.label}
          </MainLink>
        )
      })}
    </MobileNavIconGrid>
  )
}
